export enum InvoiceBillingStage {
  Deposit = 'downpayment',
  Final = 'final',
}
